import { useState, useEffect } from "react";
import { Card, Statistic, Button, Popconfirm, Typography, message } from "antd";
import {
  DollarOutlined,
  ReloadOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  getTotalCmiPayments,
  getTotalFatouratiPayments,
  getTotalCmiFatouratiAllPayments,
  resetTotalCmiPayments,
  resetTotalFatouratiPayments,
} from "../api/transactions/transactionRequest";
import { getPositiveBalanceUsers } from "../api/users/userRequest";
import PositiveBalanceUsers from "./PositiveBalanceUsers";
import PermissionRender from "./PermissionRender";

function TransactionSidebar({ currentUser }) {
  const [positiveBalanceUsers, setPositiveBalanceUsers] = useState([]);
  const [loadingBalanceUsers, setLoadingBalanceUsers] = useState(false);
  const [totalCmi, setTotalCmi] = useState(0);
  const [loadingCmi, setLoadingCmi] = useState(false);
  const [cmiResetAt, setCmiResetAt] = useState(null);
  const [totalFatourati, setTotalFatourati] = useState(0);
  const [loadingFatourati, setLoadingFatourati] = useState(false);
  const [fatouratiResetAt, setFatouratiResetAt] = useState(null);
  const [totalAllCmi, setTotalAllCmi] = useState(0);
  const [totalAllFatourati, setTotalAllFatourati] = useState(0);
  const [cmiBreakdown, setCmiBreakdown] = useState({
    infractions: 0,
    subscriptions: 0,
    tickets: 0,
  });
  const [fatouratiBreakdown, setFatouratiBreakdown] = useState({
    infractions: 0,
    subscriptions: 0,
    tickets: 0,
  });
  const [loadingTotalAll, setLoadingTotalAll] = useState(false);
  const [resettingCmi, setResettingCmi] = useState(false);
  const [resettingFatourati, setResettingFatourati] = useState(false);

  useEffect(() => {
    fetchPositiveBalanceUsers();
    fetchTotalCmi();
    fetchTotalFatourati();
    fetchTotalAll();
  }, []);

  const fetchPositiveBalanceUsers = async () => {
    setLoadingBalanceUsers(true);
    try {
      const data = await getPositiveBalanceUsers();
      setPositiveBalanceUsers(data);
    } catch (error) {
      message.error(
        "Échec de la récupération des utilisateurs avec un solde positif",
      );
    } finally {
      setLoadingBalanceUsers(false);
    }
  };

  const fetchTotalCmi = async () => {
    setLoadingCmi(true);
    try {
      const data = await getTotalCmiPayments();
      setTotalCmi(data.total || 0);
      setCmiResetAt(data.reset_at || null);
    } catch (error) {
      message.error("Échec de la récupération du total CMI");
    } finally {
      setLoadingCmi(false);
    }
  };
  const fetchTotalFatourati = async () => {
    setLoadingFatourati(true);
    try {
      const data = await getTotalFatouratiPayments();
      setTotalFatourati(data.total || 0);
      setFatouratiResetAt(data.reset_at || null);
    } catch (error) {
      message.error("Échec de la récupération du total Fatourati");
    } finally {
      setLoadingFatourati(false);
    }
  };

  const fetchTotalAll = async () => {
    setLoadingTotalAll(true);
    try {
      const data = await getTotalCmiFatouratiAllPayments();
      setTotalAllCmi(data.cmi_total || 0);
      setTotalAllFatourati(data.fatourati_total || 0);
      setCmiBreakdown({
        infractions: data.cmi_infractions || 0,
        subscriptions: data.cmi_subscriptions || 0,
        tickets: data.cmi_tickets || 0,
      });
      setFatouratiBreakdown({
        infractions: data.fatourati_infractions || 0,
        subscriptions: data.fatourati_subscriptions || 0,
        tickets: data.fatourati_tickets || 0,
      });
    } catch (error) {
      message.error("Échec de la récupération du total global");
    } finally {
      setLoadingTotalAll(false);
    }
  };

  const handleResetCmi = async () => {
    setResettingCmi(true);
    try {
      await resetTotalCmiPayments();
      message.success("Total CMI réinitialisé avec succès");
      await fetchTotalCmi();
    } catch (error) {
      message.error("Échec de la réinitialisation du total CMI");
    } finally {
      setResettingCmi(false);
    }
  };

  const handleResetFatourati = async () => {
    setResettingFatourati(true);
    try {
      await resetTotalFatouratiPayments();
      message.success("Total Fatourati réinitialisé avec succès");
      await fetchTotalFatourati();
    } catch (error) {
      message.error("Échec de la réinitialisation du total Fatourati");
    } finally {
      setResettingFatourati(false);
    }
  };

  return (
    <>
      <PositiveBalanceUsers
        users={positiveBalanceUsers}
        loading={loadingBalanceUsers}
        currentUser={currentUser}
        refreshUserBalance={fetchPositiveBalanceUsers}
      />
      {/* <Card className="mt-4 shadow-sm">
          <Statistic
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>Total des paiements CMI</span>
                <div style={{ display: "flex", gap: 4 }}>
                  <Button
                    type="text"
                    icon={<ReloadOutlined />}
                    onClick={fetchTotalCmi}
                    loading={loadingCmi}
                    size="small"
                  />
                  <PermissionRender
                    requiredPermission={["transactions", "reset_balance"]}
                  >
                    <Popconfirm
                      title="Réinitialiser le total CMI ?"
                      description="Le total CMI repartira à 0 à partir de maintenant."
                      onConfirm={handleResetCmi}
                      okText="Oui"
                      cancelText="Annuler"
                    >
                      <Button
                        type="text"
                        danger
                        icon={<DeleteOutlined />}
                        loading={resettingCmi}
                        size="small"
                      />
                    </Popconfirm>
                  </PermissionRender>
                </div>
              </div>
            }
            value={totalCmi}
            precision={2}
            suffix="MAD"
            prefix={<DollarOutlined />}
            loading={loadingCmi}
            valueStyle={{ color: "#3f8600" }}
          />
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            Réinitialisé le: {cmiResetAt || "Jamais"}
          </Typography.Text>
        </Card>
        <Card className="mt-4 shadow-sm">
          <Statistic
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>Total des paiements Fatourati</span>
                <div style={{ display: "flex", gap: 4 }}>
                  <Button
                    type="text"
                    icon={<ReloadOutlined />}
                    onClick={fetchTotalFatourati}
                    loading={loadingFatourati}
                    size="small"
                  />
                  <PermissionRender
                    requiredPermission={["transactions", "reset_balance"]}
                  >
                    <Popconfirm
                      title="Réinitialiser le total Fatourati ?"
                      description="Le total Fatourati repartira à 0 à partir de maintenant."
                      onConfirm={handleResetFatourati}
                      okText="Oui"
                      cancelText="Annuler"
                    >
                      <Button
                        type="text"
                        danger
                        icon={<DeleteOutlined />}
                        loading={resettingFatourati}
                        size="small"
                      />
                    </Popconfirm>
                  </PermissionRender>
                </div>
              </div>
            }
            value={totalFatourati}
            precision={2}
            suffix="MAD"
            prefix={<DollarOutlined />}
            loading={loadingFatourati}
            valueStyle={{ color: "#3f8600" }}
          />
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            Réinitialisé le: {fatouratiResetAt || "Jamais"}
          </Typography.Text>
        </Card> */}

      <Card className="mt-4 shadow-sm">
        <Statistic
          title={
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>Total CMI (toutes les transactions)</span>
              <Button
                type="text"
                icon={<ReloadOutlined />}
                onClick={fetchTotalAll}
                loading={loadingTotalAll}
                size="small"
              />
            </div>
          }
          value={totalAllCmi}
          precision={2}
          suffix="MAD"
          prefix={<DollarOutlined />}
          loading={loadingTotalAll}
          valueStyle={{ color: "#1d39c4" }}
        />
        {!loadingTotalAll && (
          <div style={{ marginTop: 8, fontSize: 13, color: "#595959" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Infractions</span>
              <span>{cmiBreakdown.infractions.toFixed(2)} MAD</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Abonnements</span>
              <span>{cmiBreakdown.subscriptions.toFixed(2)} MAD</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Tickets</span>
              <span>{cmiBreakdown.tickets.toFixed(2)} MAD</span>
            </div>
          </div>
        )}
      </Card>
      <Card className="mt-4 shadow-sm">
        <Statistic
          title={
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>Total Fatourati (toutes les transactions)</span>
              <Button
                type="text"
                icon={<ReloadOutlined />}
                onClick={fetchTotalAll}
                loading={loadingTotalAll}
                size="small"
              />
            </div>
          }
          value={totalAllFatourati}
          precision={2}
          suffix="MAD"
          prefix={<DollarOutlined />}
          loading={loadingTotalAll}
          valueStyle={{ color: "#1d39c4" }}
        />
        {!loadingTotalAll && (
          <div style={{ marginTop: 8, fontSize: 13, color: "#595959" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Infractions</span>
              <span>{fatouratiBreakdown.infractions.toFixed(2)} MAD</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Abonnements</span>
              <span>{fatouratiBreakdown.subscriptions.toFixed(2)} MAD</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Tickets</span>
              <span>{fatouratiBreakdown.tickets.toFixed(2)} MAD</span>
            </div>
          </div>
        )}
      </Card>
    </>
  );
}

export default TransactionSidebar;
